'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.uploadFile = exports.deleteFile = undefined;

var _callApi = require('./callApi');

var _callApi2 = _interopRequireDefault(_callApi);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var deleteFile = exports.deleteFile = function deleteFile(entityName, entityId, propName, fileId) {
  return (0, _callApi2.default)('DELETE', '/upload/' + entityName + '/' + entityId + '/' + propName + '/' + fileId, {}, 'application/json');
};
var uploadFile = exports.uploadFile = function uploadFile(entity, entity_id, prop_name, data) {
  return (0, _callApi2.default)('POST', '/upload/' + entity + '/' + entity_id + '/' + prop_name, data);
};


//////////////////
// WEBPACK FOOTER
// ./~/@hailtrace/client-api/dist/legacy/upload.js
// module id = 746
// module chunks = 0